import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8% 0px" }}
    transition={{ duration: 1, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal; `trigger` forces animation instead of in-view
export const Lines = ({ lines, className = "", lineClassName = "", delay = 0, trigger }) => {
  const anim = trigger === undefined
    ? { whileInView: "show", viewport: { once: true, margin: "-5% 0px" } }
    : { animate: trigger ? "show" : "hidden" };
  return (
    <motion.span className={`block ${className}`} initial="hidden" {...anim}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span
            className={`block ${lineClassName}`}
            variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
            transition={{ duration: 1.1, delay: delay + i * 0.12, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

// Section grows from an inset rounded card to full-bleed as it scrolls in
export const ScrollFrame = ({ children }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "start 25%"] });
  const scale = useTransform(scrollYProgress, [0, 1], [0.9, 1]);
  const borderRadius = useTransform(scrollYProgress, [0, 1], [56, 0]);
  return (
    <motion.div ref={ref} style={{ scale, borderRadius }} className="origin-top overflow-clip">
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <div className={`eyebrow flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-current" />
    {children}
  </div>
);
